import axios from 'axios';

export const getContestEntryByUser = async (auth, seriesID) => {
  console.log("seriesID",seriesID)
  try {
    const response = await axios.get(`${process.env.REACT_APP_URL_HXROAPI}/series/${seriesID}/entries/by-user`, {
      headers: {
        'X-Subscription-Key': auth.subscriptionKey,
        Authorization: `Bearer ${auth.token}`,
      },
    });
    return response.data;
  } catch (err) {
    console.error(err);
  }
};

export const getContestEntryByContestID = async (contestId, token) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_URL_HXROAPI}/contestentry/by-contest/${contestId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    console.error(err);
  }
}
